var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
import { jsx as _jsx } from "react/jsx-runtime";
import CaseGlobalViewPage from './CaseGlobalViewPage';
import { useMemo } from 'react';
export var E_DYNAMICS_VIEW_KEYS;
(function (E_DYNAMICS_VIEW_KEYS) {
    E_DYNAMICS_VIEW_KEYS["CASE_GLOBAL_VIEW_PAGE"] = "CaseGlobalViewPage";
})(E_DYNAMICS_VIEW_KEYS || (E_DYNAMICS_VIEW_KEYS = {}));
export var DynamicsView = function (key) {
    var _a;
    var dynamicsView = (_a = {},
        _a[E_DYNAMICS_VIEW_KEYS.CASE_GLOBAL_VIEW_PAGE] = function (props) { return _jsx(CaseGlobalViewPage, __assign({}, props)); },
        _a);
    // Need it to avoid useless rerender which don't impact the view container
    var view = useMemo(function () { return dynamicsView[key]; }, [key]);
    if (view) {
        return view;
    }
    else {
        console.error("An error occur : ".concat(key, " is not handle by platform"));
        // handle error
    }
};
export default DynamicsView;
